const kpopFactoryProduction = {
    host: {            
        api :"https://b6y0tmpp0c.execute-api.ap-northeast-2.amazonaws.com/kp-factory"
    },
    //cdnEndpoint: "https://zvod.kbstar.com/shared/",
    playerEndpoint: "http://mzc-cm-kp-factory-players.s3-website.ap-northeast-2.amazonaws.com/",
    deployDestination: "s3://mzc-cm-kp-factory-shared-videos",
    profile: "kpop-factory"
};

export default kpopFactoryProduction;
